import { useMemo } from 'react'
import api from '../../lib/commons/api'
import { ExternalServiceApiTokenRepository } from '../../applications/ports/externalServiceApiTokenRepository'
import {
  ExternalServiceApiTokenEntity,
  CreateExternalServiceApiTokenInput,
  CreateExternalServiceApiTokenOutput,
  RevokeExternalServiceApiTokenOutput,
} from '../../domain/entity/ExternalServiceApiTokenEntity'
import { ApiTokenScope } from '../../domain/entity/ApiTokenScope'

export const useExternalServiceApiTokenRepository =
  (): ExternalServiceApiTokenRepository => {
    return useMemo(
      () => ({
        getAll: async (): Promise<ExternalServiceApiTokenEntity[]> => {
          const response = await api.functional.request(
            'GET',
            '/api/v1/external_service_api_tokens'
          )
          return response.json as ExternalServiceApiTokenEntity[]
        },
        getScopes: async (): Promise<ApiTokenScope[]> => {
          const response = await api.functional.request(
            'GET',
            '/api/v1/external_service_api_tokens/scopes'
          )
          return response.json as ApiTokenScope[]
        },
        create: async (
          input: CreateExternalServiceApiTokenInput
        ): Promise<CreateExternalServiceApiTokenOutput> => {
          const response = await api.functional.request(
            'POST',
            '/api/v1/external_service_api_tokens',
            input
          )
          return response.json as CreateExternalServiceApiTokenOutput
        },
        revoke: async (
          uuid: string
        ): Promise<RevokeExternalServiceApiTokenOutput> => {
          const response = await api.functional.request(
            'POST',
            `/api/v1/external_service_api_tokens/revoke/${uuid}`
          )
          return response.json as RevokeExternalServiceApiTokenOutput
        },
      }),
      []
    )
  }
